import get from 'lodash/get';
import siteData from '../site_data_util';
import baseSeoUtil from '../base_seo_util';

export default function(state = {}) {
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const company = get(state, 'company.data.rows[0].name');
  const slug = get(state, 'company.data.rows[0].url');

  const isMIC = get(state, 'companyAwards.data.rows.length');
  let title = `${company}: Latest News, Work, Videos, Photos`;

  if (isMIC) {
    title = `${company}: Most Innovative Company`;
  }

  return baseSeoUtil({
    site,
    siteConf,
    title,
    url: `https://www.fastcompany.com/company/${slug}`,
    description: `Read more about ${company} on Fast Company`,
    image: `https://images.fastcompany.net/image/upload/v1480632834/fast-company-share-graphic.png`,
    articleSection: 'Most Innovative Companies',
    config: state.config
  });
}
